import type { ConfigurationOperation } from '@festina/configuration-general-types/configuration'
import type { ConfigurableServer, Optional } from '@festina-life/core'
import { useMutation } from '@tanstack/react-query'

import { largeOperationsFetcher } from './useFetchLargeOperations'

type FetchProps<O extends ConfigurationOperation> = {
  operationIds: Optional<string[]>
  server: ConfigurableServer
  validate: (operation: ConfigurationOperation) => operation is O
}

export const useLazyFetchLargeOperations = <
  T extends ConfigurationOperation,
>() =>
  useMutation({
    mutationFn: ({ server, validate, operationIds }: FetchProps<T>) =>
      largeOperationsFetcher({ server, operationIds, validate }),
  })
